import React from 'react'

const ForteDiv = (props) => {
  return (
    <div className=' overflow-hidden group flex  items-center gap-5 border-gray-500 border-b-2 min-w-full justify-between opacity-70 hover:opacity-100 hover:bg-[#f3ebe6] transition-all duration-700 ease-in-out hover:cursor-pointer p-7 textanime textanime2  '>
          <div className=' flex flex-col p-5 gap-3 group-hover:-translate-y-1 transition-all duration-700  '>

            <h1 className=' font-bold text-2xl md:text-6xl group-hover:skew-x-6 transition-all duration-700 '>{props.topic}</h1>
            <p className='text-left '>{props.intro}</p>
          </div>
          <button className='md:block hidden group-hover:-translate-y-1 transition-all  ring-1 ring-black md:rounded-full rounded-xl sm:p-1 md:p-3 mr-3  ring-offset-black  justify-around text-md   ' >
            <p>
                  <a href="/contact" class="letters">Discuss the Project</a>

            </p>
          </button>
        </div>
  )
}

export default ForteDiv
